import axios from 'axios'
import _this from '@/main.js'
import { getToken, removeToken } from './auth';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url 

  timeout: 15000 // request timeout
})
service.interceptors.request.use(config => {

  const token = getToken() && JSON.parse(getToken()).token;
  const id = getToken() && JSON.parse(getToken()).id;
  if (token) {
    config.headers.common['Authorization'] = `Bearer ${token}`
    // config.headers.common['OperatorUserId'] = `${id}`
  }

  return config
},
  err => {
    console.log(err)
    return Promise.reject(err)
  });

service.interceptors.response.use(response => {
  if (response.data.code !== "SUCCESS") {
    _this.$message.error(response.data.msg);
    if (response.data.code === 'TOKEN_INVALID') {
      removeToken()
      _this.$router.replace('/login')
    }
    return undefined
  } else {
    return response.data; // 有且必须有一个response对象被返回
  }
}, error => {

  console.log(error);
  // 对响应错误做点什么
  return Promise.reject(error);
});


export default service
